<template>
    <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
        <ion-card v-if="show" mode="ios" style="margin: 0 0 20px 0px; background: white">
            <div style="padding-top: 15px; text-align:center">
                <img :src="image"
                     @click="goTo('BrandsBeerList', title)"
                     style="display: inline-block; width: 100px; height: auto"/>
            </div>
            <ion-card-header style="padding-top: 0">
                <h2 style="margin: 0; color: #000000">{{ title }}</h2>
                <p>{{ description }}</p>
                <ion-button mode="ios"
                            fill="outline"
                            size="small"
                            @click="goTo('BrandsBeerList', title)">Zobacz piwa marki
                </ion-button>
                <ion-button mode="ios"
                            fill="outline"
                            size="small"
                            @click="windowOpen(url)">Przejdź na stronę marki
                </ion-button>
            </ion-card-header>
        </ion-card>
    </slide-x-left-transition>
</template>

<script>
    import goTo from '@/mixins/goto';

    export default {
        name: 'ItemBrand',
        props: ['index', 'slug', 'title', 'description', 'image', 'url', 'url_label'],
        mixins: [goTo],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        },
        methods: {
            windowOpen(url){
                console.log('windowOpen', url)
                let win = window.open(url, '_blank');
                win.focus();
            }
        }
    }
</script>

<style lang="scss" scoped>
    ion-card-content{
        padding: 0 20px 15px 15px;
    }
</style>